import { useUiStore } from '@/lib/store/ui';
import { type MouseEvent, useCallback } from 'react';

/** Resizable RTM columns. Service Graphing flexes, so it isn't a target. */
export type RtmPane = 'hosting' | 'services';

const BOUNDS: Record<RtmPane, { min: number; max: number }> = {
  hosting: { min: 200, max: 560 },
  services: { min: 240, max: 800 },
};

/**
 * Drag handler for the divider on the RIGHT edge of `target` — dragging right
 * widens that column (left→right delta), shrinking the Service Graphing remainder. Mirrors
 * the debug/data-stream pane-resize pattern (useDebugPaneResize).
 */
export function useRtmPaneResize(target: RtmPane) {
  const setWidth = useUiStore((s) => s.setRtmPaneWidth);
  return useCallback(
    (e: MouseEvent) => {
      e.preventDefault();
      const startX = e.clientX;
      const startW = useUiStore.getState().rtmPaneWidths[target];
      const { min, max } = BOUNDS[target];
      const onMove = (ev: globalThis.MouseEvent) => {
        const next = Math.min(max, Math.max(min, startW + (ev.clientX - startX)));
        setWidth(target, next);
      };
      const onUp = () => {
        window.removeEventListener('mousemove', onMove);
        window.removeEventListener('mouseup', onUp);
      };
      window.addEventListener('mousemove', onMove);
      window.addEventListener('mouseup', onUp);
    },
    [target, setWidth],
  );
}
